<template>
  <SoPage>
    <SoSkeleton v-if="isAuthenticating" height="86" />
    <SoAlert v-else-if="isAuthenticated" type="info" title="Authenticated">
      It looks like your account is already authenticated. Click to return to
      <a href="/" class="text-primary">home page</a>.
    </SoAlert>
    <SoAlert v-else type="error" title="Authentication failed">
      It looks like your account could not be authenticated.
      <template v-if="!isPopupApi"
        >Please refresh the page or click
        <a href="/" class="text-primary">try again</a>.</template
      >
      <template v-else
        >Please try to <a href="/" class="text-primary">refresh</a> the page or
        click
        <a href="javascript:;" class="text-primary" @click="login()">Log In</a>
        to proceed.</template
      >
    </SoAlert>
  </SoPage>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { AuthService } from "@/services/AuthService"
  import SoAlert from "@/components/SoAlert.vue"
  import SoPage from "@/components/templates/SoPage.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"

  export default defineComponent({
    components: {
      SoAlert,
      SoPage,
      SoSkeleton,
    },
    computed: {
      isPopupApi() {
        return AuthService.getIsPopupApi()
      },
      isAuthenticated() {
        return AuthService.getIsAuthenticated()
      },
      isAuthenticating() {
        return AuthService.getIsAuthenticating()
      },
    },
    methods: {
      login() {
        AuthService.ensureAuthenticated()
      },
    },
  })
</script>
